module.exports = new __parcel__URL__("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg").toString();